<template>
  <v-container fluid>
    <v-toolbar color="white" flat>
      <v-toolbar-title>Socios</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="incluirSocio()">Incluir</v-btn>
      <v-dialog v-model="dialog" persistent max-width="700px">
        <v-card class="card-rounded">
          <v-form @submit.prevent="saveSocio" ref="sociosForm" lazy-validation>
            <v-card-title>
              <span class="headline">Socio</span>
            </v-card-title>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col v-if="isInsert" cols="10">
                    <v-autocomplete
                      v-model="usuario"
                      :items="usuarios"
                      :loading="usersSearchLoading || fetchSociosLoading"
                      :search-input.sync="searchUsers"
                      hide-no-data
                      hide-selected
                      item-text="email"
                      label="E-mail Usuário"
                      no-data-text="Nenhum usuário encontrado"
                      prepend-icon="mdi-database-search"
                      return-object
                      :rules="userRules"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="10" v-else>
                    <v-input> Usuário: {{ usuario.email }} </v-input>
                  </v-col>
                  <v-col cols="6">
                    <v-switch
                      :key="acessoKey"
                      v-model="acesso.socio"
                      class="ma-2"
                      label="Socio"
                    ></v-switch>
                  </v-col>
                  <v-col cols="6">
                    <v-switch
                      v-model="acesso.adm"
                      class="ma-2"
                      label="Administrador"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="updateLoading"
                color="primary"
                text
                @click.native="closeDialog"
              >
                Fechar
              </v-btn>
              <v-btn
                :disabled="updateLoading"
                color="primary"
                text
                type="submit"
              >
                Salvar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="acessos"
      :items-per-page="10"
      :loading="fetchSociosLoading"
      :no-data-text="
        fetchSociosLoading ? 'Carregando' : 'Nenhum Registro para mostrar'
      "
      class="elevation-1"
    >
      <template v-slot:[`item.socio`]="{ item }">
        <span>{{ item.socio ? "Sim" : "Não" }}</span>
      </template>
      <template v-slot:[`item.adm`]="{ item }">
        <span>{{ item.adm ? "Sim" : "Não" }}</span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <span style="margin-right: 10px;">
          <v-icon small @click="editItem(item)">edit</v-icon></span
        >
        <span> <v-icon small @click="deleteItem(item)">delete</v-icon></span>
      </template>
    </v-data-table>
    <app-delete-dialog
      msg="Deseja Remover o socio selecionado?"
      :dialogDelete="deleteDialog"
      :id="selectedId"
      @onConfirmDelete="onConfirmDelete($event)"
      @onCancelDelete="deleteDialog = false"
    ></app-delete-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import util from "@/service/util-service";
import DeleteDialog from "@/views/delete/DeleteDialog";

export default {
  components: {
    "app-delete-dialog": DeleteDialog,
  },
  data() {
    return {
      dialog: false,
      isInsert: true,
      headers: [
        { text: "", value: "actions", sortable: false },
        {
          text: "Usuário",
          align: "left",
          sortable: true,
          value: "user.email",
        },
        {
          text: "Socio",
          align: "left",
          sortable: true,
          value: "socio",
        },
        {
          text: "Administrador",
          align: "left",
          sortable: true,
          value: "adm",
        },
      ],
      userRules: null,
      socio: {},
      acesso: {},
      fetchSociosLoading: false,
      usersSearchLoading: false,
      updateLoading: false,
      usuario: null,
      searchUsers: null,
      deleteDialog: false,
      selectedId: 0,
      acessoKey: 0,
    };
  },
  computed: {
    ...mapGetters({
      usuarios: "usuarios",
      acessos: "acessos",
    }),
  },
  watch: {
    dialog(v) {
      if (v) {
        this.socio = {};
        this.createRules();
      } else {
        this.getSociosSistema();
      }
    },
    searchUsers(value) {
      if (value)
        if (!this.usersSearchLoading && value.length >= 3) {
          if (this.usuario) {
            if (value !== this.usuario.email) {
              this.fetchUsers(value);
            }
          } else {
            this.fetchUsers(value);
          }
        }
    },
  },
  created() {
    this.getSociosSistema();
  },
  methods: {
    incluirSocio() {
      this.acesso = {};
      this.isInsert = true;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    createRules() {
      this.userRules = [(v) => !!v || "Email do usuário é obrigatório"];
    },
    resetForm() {
      if (this.$refs.sociosForm) {
        this.$refs.sociosForm.reset();
      }
    },

    validateForm() {
      if (this.$refs.sociosForm.validate()) {
        return true;
      }
      return false;
    },
    getSociosSistema() {
      this.fetchSociosLoading = true;
      this.$store
        .dispatch("fetchAcessos")
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.fetchSociosLoading = false;
        });
    },
    fetchUsers(email) {
      this.usersSearchLoading = true;
      this.$store
        .dispatch("fetchUsersByEmail", email)
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: err,
          });
        })
        .finally(() => {
          this.usersSearchLoading = false;
        });
    },

    saveSocio() {
      if (this.validateForm()) {
        this.acesso.user = this.usuario;
        this.$store
          .dispatch("saveAcessos", this.acesso)
          .then((value) => {
            console.log(value);
            if (value.type == "error") {
              this.$store.dispatch("setNotification", {
                type: "error",
                text: value.msg,
              });
            } else {
              this.$store.dispatch("setNotification", {
                type: "success",
                text: value.msg,
              });
              this.dialog = false;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.updateLoading = false;
          });
      }
    },

    editItem(item) {
      this.isInsert = false;
      this.usuario = item.user;
      this.acesso = item;
      this.acessoKey += 1;
      this.dialog = true;
    },
    deleteItem(item) {
      this.selectedId = item.id;
      this.deleteDialog = true;
    },
    onConfirmDelete(event) {
      this.deleteDialog = false;
      this.$store
        .dispatch("removeSocioAdm", event)
        .then((value) => {
          console.log(value);
          if (value.type == "error") {
            this.$store.dispatch("setNotification", {
              type: "error",
              text: value.msg,
            });
          } else {
            this.$store.dispatch("setNotification", {
              type: "success",
              text: value.msg,
            });
            this.getSociosSistema();
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.updateLoading = false;
        });
    },
  },
};
</script>
